__webpack_require__.p = "/_Resources/Static/Packages/Inwebs.MediaSaturnGekoB2B/Assets/";